import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export const BlueCatchIcon = ({ ariaLabel = 'Catch icon', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}

      <rect x="0.121094" y="0.467529" width="32" height="32" rx="16" fill="#E9F8FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.12109 14.9379C8.12109 10.4518 11.6847 6.78192 16.1211 6.78192C20.5575 6.78192 24.1211 10.4518 24.1211 14.9379C24.1211 17.6409 22.4104 20.4301 20.7271 22.4514C19.8673 23.4839 18.9717 24.3674 18.2163 25.0002C17.84 25.3155 17.4848 25.5801 17.1756 25.7713C17.0217 25.8666 16.8641 25.9531 16.7104 26.0185C16.5754 26.0759 16.3621 26.1532 16.1211 26.1532C15.8838 26.1532 15.6728 26.0786 15.5377 26.0223C15.3844 25.9583 15.227 25.8737 15.0729 25.7801C14.7635 25.5922 14.408 25.3321 14.0311 25.0213C13.2748 24.3975 12.3781 23.5246 11.5172 22.4984C9.82919 20.4865 8.12109 17.6983 8.12109 14.9379ZM16.1203 17.4486C17.8385 17.4486 19.2314 16.0557 19.2314 14.3375C19.2314 12.6193 17.8385 11.2264 16.1203 11.2264C14.402 11.2264 13.0091 12.6193 13.0091 14.3375C13.0091 16.0557 14.402 17.4486 16.1203 17.4486Z"
        fill="#0091D3"
      />
    </svg>
  );
};
